import { render } from "./PlayerScheduler.vue?vue&type=template&id=324769f0"
import script from "./PlayerScheduler.vue?vue&type=script&lang=js"
export * from "./PlayerScheduler.vue?vue&type=script&lang=js"
script.render = render

export default script